import React, { useState } from 'react';
import { useFilter } from '../../../../hooks/useFilter';
import { RiApplicationSourceQueryParamsEnum } from '../../../../constants';
import { FilterField, OptionType } from './FilterField';

const FILTER_KEY = 'source';

const policyTypeOptions = [
  {
    title: 'Third party',
    name: RiApplicationSourceQueryParamsEnum.ThirdParty,
  },
  {
    title: 'TheGuarantors',
    name: RiApplicationSourceQueryParamsEnum.TheGuarantors,
  },
];

export function PolicyTypeFilter() {
  const { getFilterOptions, handleFilterChange } = useFilter(FILTER_KEY);
  const initialOptions = getFilterOptions(policyTypeOptions);

  const [options, setOptions] = useState(initialOptions);

  function handleOptionSelect(selectedOption: OptionType) {
    const newOptions = options.map((option) =>
      option.name === selectedOption.name ? { ...option, selected: !option.selected } : option,
    );

    setOptions(newOptions);
    handleFilterChange(newOptions);
  }

  function handleOpen() {
    setOptions(initialOptions);
  }

  function handleSelectAll() {
    const newOptions = options.map((option) => ({ ...option, selected: true }));
    setOptions(newOptions);
    handleFilterChange(newOptions);
  }

  function handleOptionsClear() {
    const newOptions = options.map((option) => ({ ...option, selected: false }));
    setOptions(newOptions);
    handleFilterChange(newOptions);
  }

  return (
    <FilterField
      id="policy-type-filter"
      title="Policy type"
      options={options}
      onAllOptionsSelect={handleSelectAll}
      onOptionSelect={handleOptionSelect}
      onOptionsClear={handleOptionsClear}
      onOpen={handleOpen}
    />
  );
}
